export default {
  title: 'Näin käsittelymaksut toimivat',
  how_it_works:
    'Stripe veloittaa alustaltasi maksunsa jokaisesta verkkomaksusta, jonka ravintolasi vastaanottavat. Asettamasi käsittelymaksu on se, minkä ravintola maksaa kyseisestä maksusta. Jos se on suurempi kuin Stripen maksu, pidät erotuksen marginaalinasi. Jos se on pienempi tai et aseta sitä lainkaan, maksat erotuksen itse.',
  stripe_rates_link: 'Katso Stripen vakiohinnat',
  example: {
    intro:
      'Esimerkki: korttimaksulla maksettu {{total}} tilaus. Stripe veloittaa alustaltasi {{stripe_fee}} ({{stripe_rate}}).',
    above: 'Hintasi {{rate}}: ravintola maksaa {{fee}}, sinä pidät {{difference}}.',
    below: 'Hintasi {{rate}}: ravintola maksaa {{fee}}, sinä maksat {{difference}} erotuksen.',
    none: 'Ei hintaa (0 %:n marginaali): ravintola ei maksa mitään, sinä maksat koko {{stripe_fee}}.',
    disclaimer:
      'Stripen maksu on tässä sen tavallinen korttihinta ETA-alueella, vain havainnollistamiseksi. Todellinen maksusi riippuu kortista, sen maasta ja Stripe-hinnoittelustasi.',
  },
};
